/**
 * Splits a pasted string into individual email addresses.
 * Supports comma, semicolon, newline, and tab as separators.
 * Returns a single-element array if the input contains no separators.
 */
function splitEmails(text: string): string[] {
  return text
    .split(/[,;\s]+/)
    .map((e) => e.trim())
    .filter((e) => e.length > 0);
}

export {splitEmails};
